import { Link, Text, Image } from '@lounge-fe/ui-kit'
import { ClaimOfferTriggerProps } from './types'
import classNames from 'classnames'
import { useShopify } from '@/hooks/useShopify'
import { useCart } from '@/features/cart/hooks'
import { useMemo } from 'react'
import { computeEligibleItemsTotal } from '@/features/cart/utils'

export const ClaimOfferTrigger = ({
  triggerText,
  link,
  backgroundColor,
  images,
}: ClaimOfferTriggerProps) => {
  const { settings } = useShopify()
  const { data: { items = [] } = {} } = useCart()
  const { minimumSpend, eligibleCollections } = settings.cart_discount

  const eligibleItemsTotal = useMemo(
    () => computeEligibleItemsTotal(items, eligibleCollections),
    [items, eligibleCollections],
  )

  const isEligibleForOffer = eligibleItemsTotal >= minimumSpend

  if (!isEligibleForOffer || !minimumSpend || minimumSpend <= 0) {
    return null
  }

  return (
    <div
      className="flex flex-row justify-between justify-center items-center mx-5 mb-1 2xl:mx-6 2xl:mb-1"
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <div className="flex flex-row gap-1 p-1 pr-0 basis-2/5 flex-shrink-0">
        {images?.map((image) => (
          <Image
            data={{
              src: image.src,
              width: 72,
              height: 72,
              quality: 90,
              crop: 'center',
            }}
            alt={image.alt}
            width={72}
            height={72}
            key={image.src}
          />
        ))}
      </div>
      <div className="flex flex-row gap-2 basis-3/5 items-start justify-center">
        <Link href={link} variant="body-md" className="underline">
          {triggerText}
        </Link>
      </div>
    </div>
  )
}
